import { useState, useRef, useCallback } from 'react';
import { api } from '../api';

export const useCreation = (initialData = {}) => {
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [image, setImage] = useState(null);
  const [speakers, setSpeakers] = useState([]);
  const [speakerInput, setSpeakerInput] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const searchMembers = useCallback(async (query, communityId, forceSearch = false) => {
    if (!query || query.length < 2) {
      setSearchResults([]);
      return;
    }

    if (!communityId && !forceSearch) {
      setSearchResults([]);
      return;
    }

    setSearching(true);
    try {
      const response = await api.get(`/users?q=${query}${communityId ? `&community_id=${communityId}` : ''}`);
      // Filter out already added speakers
      const users = (response.data || response).filter(u => !speakers.some(s => s.id === u.id));
      setSearchResults(users);
    } catch (err) {
      console.error('Failed to search members:', err);
    } finally {
      setSearching(false);
    }
  }, [speakers]);

  const addSpeaker = (member) => {
    if (member && !speakers.some(s => s.id === member.id)) {
      setSpeakers([...speakers, member]);
      setSpeakerInput('');
      setSearchResults([]);
    }
  };

  const removeSpeaker = (id) => {
    setSpeakers(speakers.filter((s) => s.id !== id));
  };

  const nextStep = (validate) => {
    const errorMsg = validate ? validate() : null;
    if (errorMsg) {
      setError(errorMsg);
      return false;
    }
    setError('');
    setStep(step + 1);
    return true;
  };

  const prevStep = () => {
    setStep(Math.max(1, step - 1));
  };

  return {
    step,
    setStep,
    loading,
    setLoading,
    error,
    setError,
    image,
    setImage,
    speakers,
    setSpeakers,
    speakerInput,
    setSpeakerInput,
    fileInputRef,
    handleFileChange,
    addSpeaker,
    removeSpeaker,
    searchMembers,
    searchResults,
    searching,
    nextStep,
    prevStep,
  };
};
